export const formModules = {
    CREATE_ACCOUNT: 'createAccount',
    SELECT_NAMESPACE: 'selectNamespace',
    VERIFY_EMAIL: 'verifyEmail',
};
